//import errorHandler from './errorHandler'
import api from '../../../api'

export default {
    createCannyToken : (next) => {
        api.get('/api/v1/canny', (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    }
} 



// WEBPACK FOOTER //
// ./src/libs/system/services/canny.js